// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.25581"][{"381":0,"713":0}[chunkId]] || "1.25590") + "/" + chunkId + ".js";
};